export default __webpack_public_path__ + "static/graphik-web-super-f3cee3bcb4c4ae50571fcb35d60434f3.woff2";